import {Typography} from '@sollapay/ui';
import {useTranslation} from 'react-i18next';

import {PersonCell} from '@/components';

import type {FC} from 'react';

interface UploaderCellProps {
  uploader?: {
    name: string;
    role: string;
    avatarUrl?: string;
  };
}

export const UploaderCell: FC<UploaderCellProps> = ({uploader}) => {
  const {t} = useTranslation('common');

  if (!uploader?.name) {
    return (
      <Typography size="sm" color="tertiary">
        {t('na')}
      </Typography>
    );
  }

  return (
    <PersonCell
      name={uploader.name}
      subtitle={uploader.role ? t(`roles.${uploader.role}`) : undefined}
      avatarUrl={uploader.avatarUrl}
      emptyLabel={t('na')}
    />
  );
};

export type {UploaderCellProps};
